<div class="">
  <app-header
    (toggleSideNavEvent)="receiveToggleSideNav($event, drawer)"
  ></app-header>
  <div class="col-12" style="padding-left: 0px;padding-right: 0px;">
    <mat-sidenav-container>
      <mat-sidenav #drawer mode="side" open="true" class="example-sidenav" style="margin-top: 3%">
        <app-sidebar
        *ngIf="!toggleDocumentSideNav"
        (toggleSideNavEvent)="receiveToggleSideNav($event, drawer)"
        (toggleDocumentNavEvent)="recieveDocumentSideNav($event, drawer)"
      ></app-sidebar>
      <app-document-management
        *ngIf="toggleDocumentSideNav"
        (toggleSideNavEvent)="receiveToggleSideNav($event, drawer)"
        (toggleDocumentNavEvent)="recieveDocumentSideNav($event, drawer)"
      >
      </app-document-management>
      </mat-sidenav>
      <mat-sidenav-content style="margin-top: 3%" class="content-sidenav">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </mat-sidenav-content>
    </mat-sidenav-container>
    <!-- <mat-drawer-container class="example-container row">
      <mat-drawer
        #drawer
        class="example-sidenav"
        mode="side"
        style="margin-top: 3%"
      >
        <app-sidebar
          *ngIf="!toggleDocumentSideNav"
          (toggleSideNavEvent)="receiveToggleSideNav($event, drawer)"
          (toggleDocumentNavEvent)="recieveDocumentSideNav($event, drawer)"
        ></app-sidebar>
        <app-document-management
          *ngIf="toggleDocumentSideNav"
          (toggleSideNavEvent)="receiveToggleSideNav($event, drawer)"
          (toggleDocumentNavEvent)="recieveDocumentSideNav($event, drawer)"
        >
        </app-document-management>
      </mat-drawer>
      <mat-drawer-content style="margin-top: 2%">
        <router-outlet (activate)="onActivate($event)"></router-outlet>
      </mat-drawer-content>
    </mat-drawer-container> -->
  </div>

  <div *ngIf="decleration != null">
    <app-independence-decrelation
      (redirectDashboard)="redirectToNgOnInit($event)"
      [decleration]="decleration"
    ></app-independence-decrelation>
  </div>

  <div>
    <app-pop-up-confirmation
    [monthlyConfirmAssets]="monthlyConfirmAssets">
    </app-pop-up-confirmation>
  </div>

  <div *ngIf="showTermsOfUsesModal">
    <app-asset-terms-of-uses [assetIdForUses]="assetIdForUses" [whichModal]="whichModal" (closedModalAssetTermsEvent)="closedModalAssetTermsEvent($event)"
   ></app-asset-terms-of-uses>
  </div>
</div>
